import {useState, useCallback} from "react";
import {useDispatch} from "react-redux";
import {deleteCustomField} from "../../../redux/Actions/customFields.actions";

export const useCustomFieldsTableActions = () => {
  const dispatch = useDispatch();
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [editModalStatus, setEditModalStatus] = useState(false);
  const [selectedCustomField, setSelectedCustomField] = useState("");

  const handleDeleteCustomField = () => {
    dispatch(
      deleteCustomField(selectedCustomField.id, () => setDeleteModalStatus(false))
    );
  };

  const handleActionSelection = useCallback((action, data) => {
    switch (action) {
      case "Edit":
        setSelectedCustomField(data);
        setEditModalStatus(true);
        break;
      case "Delete":
        setSelectedCustomField(data);
        setDeleteModalStatus(true);
        break;
    }
  }, []);

  return {
    deleteModalStatus,
    deleteCustomField: handleDeleteCustomField,
    editModalStatus,
    handleActionSelection,
    selectedCustomField,
    setDeleteModalStatus,
    setEditModalStatus,
  };
};
